/**
 * Internal method for plucking a query param from the location.
 * @param {Object} location Location object with href property.
 * @param {Object} history History object with replaceState method.
 * @param {string} param The query string parameter to search for and remove.
 * @return {string} The value of the query string parameter if present.
 */
function _pluckQueryParam(location, history, param) {
  const url = new URL(location.href);
  const searchParams = url.searchParams;
  let value;
  if (searchParams.has(param)) {
    value = searchParams.get(param);
    searchParams.delete(param);
    history.replaceState(null, '', url.toString());
  }
  return value;
}

/**
 * Pluck a query param from the location.  If the query param is present,
 * it will be removed from the query string.
 * @return {string} The value of the query string parameter if present.
 */
export function pluckQueryParam(param) {
  return _pluckQueryParam(window.location, window.history, param);
}

/**
 * Matches URI Template expressions.
 * See https://datatracker.ietf.org/doc/html/rfc6570
 */
const urlTemplateRe = /\{[^{}]+\}/g;

/**
 * @param {string} href A URL.
 * @param {Object} params An object with search parameters to be added to the URL.
 * @return {string} The URL with search parameters added.
 */
export function addQueryParams(href, params) {
  const templateMatch = href.match(urlTemplateRe);
  const url = new URL(href);
  const searchParams = url.searchParams;
  for (const key in params) {
    searchParams.set(key, params[key]);
  }
  let updated = url.toString();
  if (templateMatch) {
    // The URL constructor encodes template expressions {foo} as %7Bfoo%7D.
    // This replaces the encoded expressions with the originals so the template can be evaluated.
    for (const expression of templateMatch) {
      updated = updated.replace(encodeURIComponent(expression), expression);
    }
  }
  return updated;
}
